import React from 'react';
import DataGrid, {
    Column,
    Scrolling,
    Selection,
    FilterRow,
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import DropDownBox from 'devextreme-react/drop-down-box';
import { cellRender } from '../../utils/common';
import { defaultLabels } from '../../data/defaultObjects';


const dropDownOptions = { fullScreen: true, showCloseButton: true};

export default class ProductDDBComponentMobile extends React.Component {
    quantity = 'quantity';

    constructor(props) {
        super(props);
        
        this.state = {
            currentValue: props.data.value
        };
        this.dropDownBoxRef = React.createRef();
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.contentRender = this.contentRender.bind(this);
        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
        this.calculateFilterExpression = this.calculateFilterExpression.bind(this);
        this.showPrice = props.showPrice;
        this.validateQuantity = props.validateQuantity;
        this.filterOnlyActive = props.filterOnlyActive || false;
        this.quantity = props.quantity || this.quantity;
    }

    onCellPrepared(e) {

        if (e.rowType == 'data') {
            if(e.column.dataField == "stock")
                if(e.value == 0)
                    e.cellElement.classList.add('stock-0');
           
        }
    }   
    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Regresar',
                type: 'normal',
                icon: 'chevronleft',
                stylingMode: "outlined",
                onClick: () => this.dropDownBoxRef.current.instance.close()
                
            }
        });
    }

    calculateFilterExpression(value, selectedFilterOperation, target) {  

        const values = value.split('%');
        let filters = values.map(v => {
            return ['name', 'contains', v];
        });

        const filterFull = [];

        if (filters.length > 1) {

           for (let index = 0; index < filters.length; index++) {
            const element = filters[index];
            filterFull.push(element);
            if (index < filters.length - 1) {
                filterFull.push('and');
            }
           }
           return filterFull;

        }else{
            return [filters]
        }
    }

    contentRender() {
        return (           
            <DataGrid
                dataSource={this.props.data.column.lookup.dataSource}
                keyExpr="id"                
                height={'100vh'}               
                selectedRowKeys={[this.state.currentValue]}
                hoverStateEnabled={true}
                onSelectionChanged={this.onSelectionChanged}
                focusedRowEnabled={true}
                defaultFocusedRowKey={this.state.currentValue}
                rowAlternationEnabled={true}
                allowColumnResizing={false}
                columnAutoWidth={true}
                onCellPrepared ={this.onCellPrepared}
                onToolbarPreparing={this.onToolbarPreparing}
               
            >
                <FilterRow visible={true} />                
                <Column dataField="internalCode" caption="Codigo" width={80} ></Column>
                <Column dataField="name" caption="Nombre"  calculateFilterExpression={this.calculateFilterExpression}></Column>
                <Column dataField="price" caption="Precio" visible={this.showPrice} cellRender={cellRender()} width={90}></Column>
                <Column dataField="stock" caption="Cant" width={70}></Column>
                <Column dataField="disponible" caption="Disp" width={90}></Column>
                <Column dataField="um" caption="Unidad Medida" width={120}></Column>
                <Column dataField="family" caption={defaultLabels.family} width={120} visible={true}></Column>
                <Column dataField="cost" caption="Costo" visible={!this.showPrice} cellRender={cellRender()} width={90}></Column>                 
                <Scrolling mode="virtual" />
                <Selection mode="single" />
            </DataGrid>
        );
    }

    onSelectionChanged(e) {

        this.setState({ currentValue: e.selectedRowKeys[0] });
        this.props.data.setValue(this.state.currentValue);
        
        if (e.selectedRowKeys.length > 0) { 
            const data = e.selectedRowsData[0];
            if(this.validateQuantity && data.stock <= 0){
                notify("No hay stock disponible", "error", 1000);
            }else{
                this.dropDownBoxRef.current.instance.close();     
                this.props.data.component.editCell(this.props.data.rowIndex, this.quantity);
             }               
            
        }

    }    

    render() {
        return (
            <DropDownBox
                ref={this.dropDownBoxRef}
                key="id"
                dropDownOptions={dropDownOptions}
                dataSource={this.props.data.column.lookup.dataSource}
                value={this.state.currentValue}
                displayExpr={item => item ? `${item.internalCode} - ${item.name}` : ''}
                valueExpr="id"                
                contentRender={this.contentRender}>
            </DropDownBox>
        );
    }
}